// TODO: could probably give this a better name and structure, but simply moving it
// into the new package for now to pass type checks for DD_LOGS
export function handleDatadogLogger(userUID?: string): void {
  let uid = ''
  if (userUID) uid = userUID
  window.DD_LOGS &&
    window.DD_LOGS.onReady(() => {
      window.DD_LOGS?.addLoggerGlobalContext('uid', uid)
    })
}
